import { createSelector } from "@reduxjs/toolkit";
import { StoreState } from "../../store";

const selector = (state: StoreState) => state.dashboard;

export const dashboardSelectors = {
    data: createSelector(selector, (dashboard) => dashboard.data),
}
